import { useMemo } from 'react';
import { AssetListAsset } from 'src/@types/assets';
import { GenericAssetRenderingProps } from 'src/hooks/assets/types';
import useVelocityAccountStore from 'src/stores/useVelocityAccountsStore';
import { ENUM_UTILS } from '@velocity-exchange/common';
import { SpotBalanceType } from '@velocity-exchange/sdk';

export function useSubaccountAssets<T extends AssetListAsset>(
	assetList: T[],
	overrideCurrentUserKey?: string
): GenericAssetRenderingProps<T>[] {
	const currentUserAccountState = useVelocityAccountStore(
		(s) => s.accounts[overrideCurrentUserKey ?? s.currentUserKey ?? '']
	);
	const userBalances = currentUserAccountState?.spotBalances ?? [];

	return useMemo(
		() =>
			assetList.map((asset) => {
				if (!currentUserAccountState) {
					return {
						...asset,
						uiAmount: 0,
					};
				}

				const balance = userBalances.find(
					(b) => b.asset.mint.toString() === asset.mint
				);

				if (
					balance &&
					ENUM_UTILS.match(balance.balanceType, SpotBalanceType.DEPOSIT)
				) {
					return {
						...asset,
						uiAmount: balance.balance.toNum(),
					};
				}

				return {
					...asset,
					uiAmount: 0,
				};
			}) as GenericAssetRenderingProps<T>[],
		[assetList, currentUserAccountState, userBalances]
	);
}
